/* CE Search Page v1.0 — Meilisearch faceted search grid (Fashionphile-style)
   Renders into #CeSearchPage. Facets + live counts + sort + pagination + URL sync. */
(function () {
  'use strict';

  const root = document.getElementById('CeSearchPage');
  if (!root) return;

  const SEARCH_URL = 'https://search.collectoredit.com';
  const TENANT_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzZWFyY2hSdWxlcyI6eyJwcm9kdWN0cyI6eyJmaWx0ZXIiOiJzdG9yZXMgPSBjb2xsZWN0b3JlZGl0In19LCJhcGlLZXlVaWQiOiI0M2ZlY2Y1Mi02YWMwLTRkNTAtOWNjYi1lMGViZGY4YjIzNjYifQ.d_kwOHo_K8a-Ngz_EF2AHuUhIfBHWsbdbZLV9seHW6s';
  const INDEX = 'products';
  const HITS_PER_PAGE = 120;

  // On a collection page this is the collection handle; on the search page it's empty.
  // When set, every query is locked to that collection (in addition to user facets).
  const COLLECTION = root.dataset.collection || '';
  const COLLECTION_TITLE = root.dataset.collectionTitle || '';
  // New Arrivals = a rolling date window (items added to CE in the last 7 days), NOT a tag.
  // 'new' is the canonical published handle; 'new-arrivals' kept for the legacy/unpublished one.
  const IS_NEW = (COLLECTION === 'new' || COLLECTION === 'new-arrivals');
  const NEW_PRICE_FLOOR = 350; // belt: repriced items under the listing floor never surface on New Arrivals
  // Direct DB-field filter for this collection (e.g. brand IN ["Chanel"], category = "Bags"),
  // set per-collection via the custom.meili_filter metafield. When present we filter the real
  // DB-backed fields in Meili instead of the precomputed ce_collections membership. Collections
  // without it (sale, model lines, vintage) fall back to the ce_collections tag below.
  let META_FILTER = (root.dataset.meiliFilter || '').trim();

  const FACETS = [
    { key: 'brand', label: 'Designer', searchable: true },
    { key: 'category', label: 'Category' },
    { key: 'product_type', label: 'Style' },
    { key: 'color', label: 'Color', swatch: true },
    { key: 'material', label: 'Material' },
    { key: 'condition', label: 'Condition' },
    { key: 'size', label: 'Size' },
    { key: 'badges', label: 'Featured' }
  ];

  // color name -> swatch CSS (canonical color set)
  const COLOR_HEX = {
    Black: '#111', White: '#fff', Gray: '#9a9a9a', Grey: '#9a9a9a', Brown: '#7a4a23',
    Beige: '#e3d4ba', Tan: '#cda57a', Khaki: '#b5a572', Cream: '#f4ecd8', Ivory: '#fffff0',
    Gold: 'linear-gradient(135deg,#e6c200,#b8860b)', Silver: 'linear-gradient(135deg,#e8e8e8,#9a9a9a)',
    Red: '#c0392b', Burgundy: '#6b1f2a', Pink: '#f4b8c4', Orange: '#e67e22', Yellow: '#f1c40f',
    Green: '#2e7d4f', Blue: '#2d6cdf', Navy: '#1f2a44', Purple: '#7d4f9e',
    Multicolor: 'linear-gradient(135deg,#e74c3c,#f1c40f 35%,#2ecc71 65%,#2d6cdf)', Clear: 'transparent'
  };
  function swatchStyle(name) {
    const v = COLOR_HEX[name];
    if (!v) return 'background:#ddd';
    return (v.indexOf('gradient') !== -1 ? 'background-image:' : 'background:') + v;
  }

  const SORTS = [
    { v: '', label: 'Relevance' },
    { v: 'created_at_timestamp:desc', label: 'Newest' },
    { v: 'price:asc', label: 'Price: Low to High' },
    { v: 'price:desc', label: 'Price: High to Low' },
    { v: 'views_count:desc', label: 'Most Popular' }
  ];

  // In-grid promotional banners (page 1, unfiltered collection views only). Edit freely.
  const GRID_PROMOS = [
    { at: 8, href: '/pages/membership', kicker: 'Members save more', title: 'The Collector’s Circle', sub: '5% off every order, 48-hour early access & members-only drops', cta: 'Explore membership', image: 'https://cdn.shopify.com/s/files/1/0738/1021/5095/files/collectors-circle-hermes-mini-kelly-v2.jpg' },
    { at: 40, href: '/collections/new', kicker: 'Fresh finds', title: 'New This Week', sub: 'Newly authenticated arrivals, added daily', cta: 'Shop New In', image: 'https://cdn.shopify.com/s/files/1/0738/1021/5095/files/new-this-week-chanel-pink-flap.jpg' },
    { at: 76, href: '/pages/authenticity-guarantee', kicker: 'Expertly authenticated', title: 'Verified In-House', sub: 'Every piece inspected by our specialists before it ships', cta: 'Our guarantee', image: 'https://cdn.shopify.com/s/files/1/0738/1021/5095/files/verified-in-house-chanel-white-flap-v2.jpg' }
  ];

  const BUCKETS = [
    { id: 'u500', label: 'Under $500' },
    { id: '500-1000', label: '$500 – $1,000' },
    { id: '1000-2500', label: '$1,000 – $2,500' },
    { id: '2500-5000', label: '$2,500 – $5,000' },
    { id: 'o5000', label: 'Over $5,000' }
  ];
  const BUCKET_FILTER = {
    'u500': 'price < 500',
    '500-1000': 'price >= 500 AND price <= 1000',
    '1000-2500': 'price >= 1000 AND price <= 2500',
    '2500-5000': 'price >= 2500 AND price <= 5000',
    'o5000': 'price > 5000'
  };
  const CONDITION_ORDER = ['New', 'Excellent', 'Very Good', 'Good', 'Fair'];
  const SEARCH_ICON = '<svg viewBox="0 0 20 20" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.7"><circle cx="9" cy="9" r="6"></circle><path d="M13.5 13.5l4 4" stroke-linecap="round"></path></svg>';

  // ---------- state <-> URL ----------
  const state = { q: '', filters: {}, priceMin: '', priceMax: '', priceBuckets: [], sale: false, sort: '', page: 1 };

  function readURL() {
    const p = new URLSearchParams(location.search);
    state.q = p.get('q') || ''; state._ms = null;
    // Collections (incl New Arrivals) default to Newest by DB-added date; search keeps Relevance.
    state.sort = p.get('sort') || (COLLECTION ? 'created_at_timestamp:desc' : '');
    state.page = parseInt(p.get('page') || '1', 10) || 1;
    state.priceMin = p.get('price_min') || '';
    state.priceMax = p.get('price_max') || '';
    state.priceBuckets = (p.get('price_b') || '').split('||').filter(Boolean);
    state.sale = p.get('sale') === '1';
    state.filters = {};
    FACETS.forEach(function (f) {
      const v = p.get('f_' + f.key);
      if (v) state.filters[f.key] = v.split('||').filter(Boolean);
    });
  }

  function writeURL() {
    const p = new URLSearchParams();
    var _tab = new URLSearchParams(location.search).get('tab');
    if (_tab) p.set('tab', _tab);
    if (state.q) p.set('q', state.q);
    var defSort = COLLECTION ? 'created_at_timestamp:desc' : '';
    if (state.sort && state.sort !== defSort) p.set('sort', state.sort);
    if (state.page > 1) p.set('page', String(state.page));
    if (state.priceMin) p.set('price_min', state.priceMin);
    if (state.priceMax) p.set('price_max', state.priceMax);
    if (state.priceBuckets.length) p.set('price_b', state.priceBuckets.join('||'));
    if (state.sale) p.set('sale', '1');
    FACETS.forEach(function (f) {
      const v = state.filters[f.key];
      if (v && v.length) p.set('f_' + f.key, v.join('||'));
    });
    history.replaceState(null, '', location.pathname + (p.toString() ? '?' + p.toString() : ''));
  }

  // ---------- query ----------
  function esc(v) { return String(v).replace(/\\/g, '\\\\').replace(/'/g, "\\'"); }

  function buildFilter(excludeKey) {
    const parts = [];
    if (IS_NEW) {
      // New Arrivals = ALL CE products, newest day first, best pieces first within a day.
      // The tenant token already scopes to CE; keep a price floor so cheap strays never surface.
      parts.push('price >= ' + NEW_PRICE_FLOOR);
    } else if (META_FILTER) {
      parts.push('(' + META_FILTER + ')');
    } else if (COLLECTION) {
      parts.push('ce_collections = "' + esc(COLLECTION) + '"');
    }
    Object.keys(state.filters).forEach(function (k) {
      if (k === excludeKey) return;
      const vals = state.filters[k];
      if (vals && vals.length) {
        parts.push(k + " IN ['" + vals.map(esc).join("','") + "']");
      }
    });
    if (state.priceBuckets.length) {
      const or = state.priceBuckets.map(function (b) { return BUCKET_FILTER[b]; }).filter(Boolean);
      if (or.length) parts.push('(' + or.map(function (x) { return '(' + x + ')'; }).join(' OR ') + ')');
    } else {
      if (state.priceMin !== '') parts.push('price >= ' + parseFloat(state.priceMin));
      if (state.priceMax !== '') parts.push('price <= ' + parseFloat(state.priceMax));
    }
    if (state.sale) parts.push('ce_collections = "sale"');
    return parts.join(' AND ');
  }

  // Every page shows enough products so (products-per-page + 2-row promo spans) fills complete
  // grid rows (multiple of 12 = flush at 4/3/2 columns) -> no trailing empty slots on any page.
  // Promos repeat identically each page (same "at" positions), so every page needs the same bump.
  function pageSize() {
    if (state.q) return 120;
    var n = activePromos().filter(function (p) { return (parseInt(p.at, 10) || 8) < 120; }).length;
    var units = 2 * n, L = 120;
    while (((L + units) % 12) !== 0) L++;
    return L;
  }
  async function query() {
    var PS = pageSize();
    var win = { offset: (state.page - 1) * PS, limit: PS };
    const body = {
      q: state.q,
      facets: FACETS.map(function (f) { return f.key; }).concat(['ce_collections']),
      offset: win.offset,
      limit: win.limit,
      attributesToRetrieve: ['sku', 'title', 'brand', 'price', 'image_ce', 'image2_ce', 'handle_ce', 'condition', 'badges', 'seller_bgfix']
    };
    const f = buildFilter();
    if (f) body.filter = f;
    // Search precision: require ALL query words to match (stops "c de cartier" filling with
    // random 'de'/'c' items). If that yields nothing (typo / no stock), fall back to loose.
    if (state.q) body.matchingStrategy = state._ms || 'all';
    var _sv = state.sort;
    // New Arrivals: "newest" = newest ON CE (upload time), matching the homepage New to the Edit widget
    if (IS_NEW && _sv === 'created_at_timestamp:desc') {
      // newest DAY first; within a day, desirability (price/brand/category blend) first.
      // seller_deprio pushes flagged sellers (dirty imagery) behind everything else.
      body.sort = ['seller_deprio:asc', 'ce_added_day:desc', 'nb_brand_seq:asc', 'nb_score:desc'];
    } else if (_sv === 'created_at_timestamp:desc') {
      // default collection sort: same deprio-first treatment
      body.sort = ['seller_deprio:asc', 'created_at_timestamp:desc'];
    } else if (_sv) { body.sort = [_sv]; }
    const res = await fetch(SEARCH_URL + '/indexes/' + INDEX + '/search', {
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + TENANT_TOKEN, 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
    let data = await res.json();
    if (state.q && body.matchingStrategy === 'all' && !(data.hits && data.hits.length)) {
      state._ms = 'last';
      body.matchingStrategy = 'last';
      const res2 = await fetch(SEARCH_URL + '/indexes/' + INDEX + '/search', {
        method: 'POST',
        headers: { 'Authorization': 'Bearer ' + TENANT_TOKEN, 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      data = await res2.json();
    } else if (state.q) {
      state._ms = body.matchingStrategy;
    }
    // CE: never surface add-on/service products (e.g. Shipping Protection) in search.
    if (data && data.hits) data.hits = data.hits.filter(function (h) {
      return h && h.handle_ce && h.handle_ce !== 'shipping-protection' && (h.title || '').indexOf('Shipping Protection') < 0;
    });
    var _tot = (data.estimatedTotalHits != null) ? data.estimatedTotalHits : (data.totalHits || 0);
    data.totalPages = Math.max(1, Math.ceil(_tot / PS));
    return data;
  }

  // ---------- rendering ----------
  function el(html) {
    const t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstChild;
  }

  function escapeHtml(s) {
    const d = document.createElement('div');
    d.textContent = s == null ? '' : s;
    return d.innerHTML;
  }


  // Title never repeats the brand (brand line above already shows it)
  function ceStripBrand(title, brand) {
    title = String(title || ''); brand = String(brand || '');
    if (brand && title.toLowerCase().indexOf(brand.toLowerCase()) === 0) {
      var rest = title.slice(brand.length).replace(/^[\s\-–—:,]+/, '');
      if (rest) return rest;
    }
    return title;
  }
  function fmtPrice(p) {
    return '$' + (p || 0).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function fixImg(u) { return u || ''; }  // images come pre-branded as image_ce from the index

  // Promo banners: prefer theme-editor blocks (#ce-grid-promos JSON), else the hardcoded
  // GRID_PROMOS. Show a promo when its `collections` is blank (all pages) or includes
  // the current collection handle.
  function activePromos() {
    var list = GRID_PROMOS;
    var el = document.getElementById('ce-grid-promos');
    if (el) { try { var j = JSON.parse(el.textContent || '[]'); if (j && j.length) list = j; } catch (e) {} }
    var col = (COLLECTION || '').toLowerCase();
    return list.filter(function (p) {
      if (!p.collections) return true;
      return p.collections.split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean).indexOf(col) > -1;
    });
  }
  function promoHTML(p) {
    var hasImg = !!p.image;
    var bg = hasImg ? ' style="background-image:url(' + p.image + ')"' : '';
    return '<div class="ce-sp__promo' + (hasImg ? ' ce-sp__promo--img' : '') + '"' + bg + '><a href="' + (p.href || '/collections/new') + '">' +
      (p.kicker ? '<span class="ce-sp__promo-kicker">' + p.kicker + '</span>' : '') +
      '<span class="ce-sp__promo-title">' + (p.title || '') + '</span>' +
      (p.sub ? '<span class="ce-sp__promo-sub">' + p.sub + '</span>' : '') +
      '<span class="ce-sp__promo-cta">' + (p.cta || 'Shop now') + '</span>' +
      '</a></div>';
  }

  function skeleton() {
    var heading = (COLLECTION && COLLECTION_TITLE)
      ? '<h1 class="ce-collection-title">' + escapeHtml(COLLECTION_TITLE) + '</h1>' : '';
    return heading + '<div class="ce-sp__layout">' +
      '<aside class="ce-sp__facets" id="CeFacets"></aside>' +
      '<div class="ce-sp__main">' +
      '<div class="ce-sp__topbar">' +
      '<button class="ce-sp__filter-toggle" id="CeFilterToggle" type="button">Filters</button>' +
      '<span class="ce-sp__count" id="CeCount"></span>' +
      '<span class="ce-sp__chips" id="CeChips"></span>' +
      '<div class="ce-sp__sortwrap"><span class="ce-sp__sort-label">Sort by</span><div class="ce-sp__sortdd" id="CeSort"></div></div>' +
      '</div>' +
      '<div class="ce-sp__grid" id="CeGrid"></div>' +
      '<div class="ce-sp__pager" id="CePager"></div>' +
      '</div></div>';
  }

  function renderSort() {
    const host = document.getElementById('CeSort');
    const cur = SORTS.filter(function (s) { return s.v === state.sort; })[0] || SORTS[0];
    host.innerHTML = '<button type="button" class="ce-sp__sort-btn" aria-haspopup="listbox"><span>' + cur.label + '</span>' +
      '<svg viewBox="0 0 12 12" width="11" height="11" aria-hidden="true"><path d="M2 4l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.5"></path></svg></button>' +
      '<ul class="ce-sp__sort-menu" role="listbox" hidden>' +
      SORTS.map(function (s) { return '<li class="ce-sp__sort-opt' + (s.v === state.sort ? ' is-sel' : '') + '" data-v="' + s.v + '" role="option">' + s.label + '</li>'; }).join('') +
      '</ul>';
    const btn = host.querySelector('.ce-sp__sort-btn'), menu = host.querySelector('.ce-sp__sort-menu');
    btn.onclick = function (e) { e.stopPropagation(); menu.hidden = !menu.hidden; };
    menu.querySelectorAll('.ce-sp__sort-opt').forEach(function (li) {
      li.onclick = function () { state.sort = li.getAttribute('data-v'); state.page = 1; refresh(); };
    });
  }

  function renderFacets(dist) {
    const wrap = document.getElementById('CeFacets');
    wrap.innerHTML = '<div class="ce-sp__facets-head">Filter by' +
      '<button type="button" class="ce-sp__clear" id="CeClearAll">Clear all</button>' +
      '<button type="button" class="ce-sp__facets-x" id="CeFacetsX" aria-label="Close filters">\u2715</button></div>';
    document.getElementById('CeFacetsX').onclick = function () { root.classList.remove('ce-sp--facets-open'); };

    // ----- Price: range checkboxes + manual min/max -----
    let priceHtml = '<details class="ce-sp__facet" open><summary>Price</summary><div class="ce-sp__facet-body"><div class="ce-sp__facet-list">';
    BUCKETS.forEach(function (b) {
      const ck = state.priceBuckets.indexOf(b.id) !== -1;
      priceHtml += '<label class="ce-sp__opt"><input type="checkbox" data-bucket="' + b.id + '"' + (ck ? ' checked' : '') + '><span class="ce-sp__opt-name">' + b.label + '</span></label>';
    });
    priceHtml += '</div><div class="ce-sp__price-row">' +
      '<input type="number" id="CePriceMin" placeholder="Min" min="0" value="' + escapeHtml(state.priceMin) + '">' +
      '<span>&ndash;</span>' +
      '<input type="number" id="CePriceMax" placeholder="Max" min="0" value="' + escapeHtml(state.priceMax) + '">' +
      '<button type="button" id="CePriceGo" class="ce-sp__set">Set</button>' +
      '</div></div></details>';
    wrap.insertAdjacentHTML('beforeend', priceHtml);

    // ----- Sale -----
    const saleCount = (dist && dist.ce_collections && dist.ce_collections.sale) || 0;
    if (saleCount > 0 || state.sale) {
      wrap.insertAdjacentHTML('beforeend', '<details class="ce-sp__facet"' + (state.sale ? ' open' : '') + '><summary>Sale</summary><div class="ce-sp__facet-body"><div class="ce-sp__facet-list">' +
        '<label class="ce-sp__opt"><input type="checkbox" id="CeSale"' + (state.sale ? ' checked' : '') + '><span class="ce-sp__opt-name">Sale</span><span class="ce-sp__opt-count">(' + saleCount + ')</span></label>' +
        '</div></div></details>');
    }

    // ----- standard facets -----
    FACETS.forEach(function (f) {
      const counts = (dist && dist[f.key]) || {};
      const baseCounts = (BASE_FACETS && BASE_FACETS[f.key]) || counts;
      const selected = state.filters[f.key] || [];
      let names = Object.keys(baseCounts);
      Object.keys(counts).forEach(function (v) { if (names.indexOf(v) === -1) names.push(v); });
      selected.forEach(function (v) { if (names.indexOf(v) === -1) names.push(v); });
      if (names.length <= 1) return; // a one-option filter adds nothing (e.g. Category on Watches)

      if (f.key === 'condition') {
        names.sort(function (a, b) {
          let ia = CONDITION_ORDER.indexOf(a), ib = CONDITION_ORDER.indexOf(b);
          if (ia === -1) ia = 99; if (ib === -1) ib = 99;
          return ia - ib;
        });
      } else {
        names.sort(function (a, b) { return (counts[b] || 0) - (counts[a] || 0); });
      }

      const open = selected.length > 0 || f.key === 'brand' || f.key === 'category';
      const sec = el('<details class="ce-sp__facet"' + (open ? ' open' : '') + '><summary>' + f.label +
        (selected.length ? ' <span class="ce-sp__facet-n">' + selected.length + '</span>' : '') +
        '</summary><div class="ce-sp__facet-body"></div></details>');
      const body = sec.querySelector('.ce-sp__facet-body');

      if (f.searchable && names.length > 8) {
        const sw = el('<div class="ce-sp__facet-search-wrap"><input class="ce-sp__facet-search" type="text" placeholder="Search"><span class="ce-sp__facet-search-icon">' + SEARCH_ICON + '</span></div>');
        const si = sw.querySelector('input');
        si.addEventListener('input', function () {
          const t = si.value.toLowerCase();
          body.querySelectorAll('.ce-sp__opt').forEach(function (lab) {
            lab.style.display = lab.textContent.toLowerCase().indexOf(t) !== -1 ? '' : 'none';
          });
        });
        body.appendChild(sw);
      }

      const list = el('<div class="ce-sp__facet-list"></div>');
      names.forEach(function (name, idx) {
        const id = 'f-' + f.key + '-' + name.replace(/\W+/g, '-');
        const checked = selected.indexOf(name) !== -1;
        const swatch = f.swatch ? '<span class="ce-sp__swatch" style="' + swatchStyle(name) + '"></span>' : '';
        const extra = (idx >= 8 && !checked) ? ' ce-sp__opt--extra' : '';
        const lab = el('<label class="ce-sp__opt' + extra + '" for="' + id + '">' +
          '<input type="checkbox" id="' + id + '"' + (checked ? ' checked' : '') + '>' +
          swatch +
          '<span class="ce-sp__opt-name">' + escapeHtml(name) + '</span>' +
          '<span class="ce-sp__opt-count">(' + (counts[name] || 0) + ')</span></label>');
        lab.querySelector('input').addEventListener('change', function (e) {
          const cur = state.filters[f.key] || [];
          if (e.target.checked) state.filters[f.key] = cur.concat([name]);
          else state.filters[f.key] = cur.filter(function (v) { return v !== name; });
          state.page = 1;
          refresh();
        });
        list.appendChild(lab);
      });
      body.appendChild(list);
      const extras = names.filter(function (n, i) { return i >= 8 && selected.indexOf(n) === -1; }).length;
      if (extras > 0) {
        const more = el('<button type="button" class="ce-sp__showmore">Show all (' + names.length + ')</button>');
        more.addEventListener('click', function () {
          const all = sec.classList.toggle('ce-sp__facet--all');
          more.textContent = all ? 'Show less' : 'Show all (' + names.length + ')';
        });
        body.appendChild(more);
      }
      wrap.appendChild(sec);
    });

    document.getElementById('CeClearAll').onclick = function () {
      state.filters = {}; state.priceMin = ''; state.priceMax = ''; state.priceBuckets = []; state.sale = false; state.page = 1; refresh();
    };
    document.getElementById('CePriceGo').onclick = function () {
      state.priceMin = document.getElementById('CePriceMin').value;
      state.priceMax = document.getElementById('CePriceMax').value;
      state.priceBuckets = []; state.page = 1; refresh();
    };
    wrap.querySelectorAll('input[data-bucket]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        const bid = cb.getAttribute('data-bucket');
        if (cb.checked) state.priceBuckets = state.priceBuckets.concat([bid]);
        else state.priceBuckets = state.priceBuckets.filter(function (x) { return x !== bid; });
        state.priceMin = ''; state.priceMax = ''; state.page = 1; refresh();
      });
    });
    const saleCb = document.getElementById('CeSale');
    if (saleCb) saleCb.addEventListener('change', function () { state.sale = saleCb.checked; state.page = 1; refresh(); });
  }

  function renderChips() {
    const wrap = document.getElementById('CeChips');
    let html = '';
    Object.keys(state.filters).forEach(function (k) {
      (state.filters[k] || []).forEach(function (v) {
        html += '<button type="button" class="ce-sp__chip" data-k="' + k + '" data-v="' + escapeHtml(v) + '">' + escapeHtml(v) + ' &times;</button>';
      });
    });
    if (state.priceMin || state.priceMax) {
      html += '<button type="button" class="ce-sp__chip" data-k="__price">' +
        (state.priceMin ? '$' + state.priceMin : '$0') + '&ndash;' + (state.priceMax ? '$' + state.priceMax : '&infin;') + ' &times;</button>';
    }
    state.priceBuckets.forEach(function (b) {
      const lbl = (BUCKETS.filter(function (x) { return x.id === b; })[0] || {}).label || b;
      html += '<button type="button" class="ce-sp__chip" data-k="__bucket" data-v="' + b + '">' + lbl + ' &times;</button>';
    });
    if (state.sale) html += '<button type="button" class="ce-sp__chip" data-k="__sale">Sale &times;</button>';
    wrap.innerHTML = html;
    wrap.querySelectorAll('.ce-sp__chip').forEach(function (chip) {
      chip.onclick = function () {
        const k = chip.getAttribute('data-k');
        if (k === '__price') { state.priceMin = ''; state.priceMax = ''; }
        else if (k === '__bucket') { const v = chip.getAttribute('data-v'); state.priceBuckets = state.priceBuckets.filter(function (x) { return x !== v; }); }
        else if (k === '__sale') { state.sale = false; }
        else {
          const v = chip.getAttribute('data-v');
          state.filters[k] = (state.filters[k] || []).filter(function (x) { return x !== v; });
        }
        state.page = 1;
        refresh();
      };
    });
  }

  function renderGrid(data) {
    const grid = document.getElementById('CeGrid');
    if (!data.hits.length) {
      grid.innerHTML = '<div class="ce-sp__none">No items match. Try removing a filter.</div>';
      return;
    }
    var _badgeSeen = {};
    var cards = data.hits.map(function (h) {
      var _bl = (h.badges && h.badges.length) ? h.badges[0] : '';
      // spread: every 8th eligible card carries the badge — no clusters, ~12% density
      if (_bl) { _badgeSeen[_bl] = (_badgeSeen[_bl] || 0) + 1; if ((_badgeSeen[_bl] - 1) % 8 !== 0) _bl = ''; }
      const badge = _bl ? '<span class="ce-sp__badge">' + escapeHtml(_bl) + '</span>' : '';
      // Second image rendered as its own lazy <img> overlay (swapped via CSS opacity on hover).
      // loading="lazy" => it downloads as the card scrolls into view, so it's cached before hover
      // = instant swap (the old approach fetched it on mouseenter, causing the lag).
      // Alt image holds its URL in data-src (NOT src) — native loading="lazy" never fires for an
      // opacity:0/occluded image, so we preload it via IntersectionObserver below instead.
      const altImg = h.image2_ce ? '<img class="ce-sp__img-alt" data-src="' + h.image2_ce + '" alt="" aria-hidden="true">' : '';
      return '<a class="ce-sp__card' + (h.seller_bgfix ? ' ce-sp__card--bg' + h.seller_bgfix : '') + '" href="/products/' + (h.handle_ce || '') + '">' +
        '<span class="ce-sp__card-imgwrap">' + badge +
        '<img class="ce-sp__img-main" loading="lazy" src="' + (h.image_ce || '') + '" alt="' + escapeHtml(h.title) + '">' + altImg + '</span>' +
        '<span class="ce-sp__card-brand">' + escapeHtml(h.brand || '') + '</span>' +
        '<span class="ce-sp__card-title">' + escapeHtml(ceStripBrand(h.title, h.brand)) + '</span>' +
        (h.condition ? '<span class="ce-sp__card-cond">Condition: ' + escapeHtml(h.condition) + '</span>' : '') +
        '<span class="ce-sp__card-price">' + fmtPrice(h.price) + '</span>' +
        '</a>';
    });
    // weave in promotional banners on every page (collection/browse, not active text search)
    if (!state.q) {
      var inserts = [];
      activePromos().forEach(function (p) {
        var step = (p.every && p.every > 0) ? p.every : 0;
        var pos = p.at;
        do { inserts.push({ pos: pos, html: promoHTML(p) }); pos += step; } while (step > 0 && pos < cards.length);
      });
      inserts = inserts.filter(function (ins) { return cards.length > ins.pos; });
      inserts.sort(function (a, b) { return b.pos - a.pos; });
      // Show ALL configured promos. The grid uses grid-auto-flow:dense, so any hole a promo's
      // 2-row span would create is backfilled by later product cards -> no mid-grid gaps; at most
      // a partial final row (acceptable "last page" gap).
      inserts.forEach(function (ins) { cards.splice(ins.pos, 0, ins.html); });
    }
    grid.innerHTML = cards.join('');
    // Preload each card's hover (2nd) image as it approaches the viewport, so the hover swap is
    // instant. IntersectionObserver fires on geometric intersection regardless of opacity, which
    // native lazy-loading does not for the opacity:0 alt image.
    var altImgs = grid.querySelectorAll('.ce-sp__img-alt[data-src]');
    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var im = e.target;
          if (im.dataset.src) { im.src = im.dataset.src; im.removeAttribute('data-src'); }
          io.unobserve(im);
        });
      }, { rootMargin: '400px' });
      altImgs.forEach(function (im) { io.observe(im); });
    } else {
      altImgs.forEach(function (im) { im.src = im.dataset.src; im.removeAttribute('data-src'); });
    }
  }

  function renderPager(data) {
    const wrap = document.getElementById('CePager');
    const total = data.totalPages || 1;
    if (total <= 1) { wrap.innerHTML = ''; return; }
    const cur = state.page;
    let html = '';
    function btn(p, label, isCur) {
      return '<button type="button" class="ce-sp__page' + (isCur ? ' ce-sp__page--cur' : '') + '" data-p="' + p + '">' + label + '</button>';
    }
    // Clean window: no total/last-page, no ellipsis; prev only when not first, next only when not last.
    if (cur > 1) html += btn(cur - 1, '\u2039', false);
    var start = Math.max(1, cur - 2);
    var end = Math.min(total, start + 4);
    start = Math.max(1, end - 4);
    for (var i = start; i <= end; i++) html += btn(i, String(i), i === cur);
    if (cur < total) html += btn(cur + 1, '\u203a', false);
    wrap.innerHTML = html;
    wrap.querySelectorAll('.ce-sp__page').forEach(function (b) {
      b.onclick = function () {
        const p = parseInt(b.getAttribute('data-p'), 10);
        if (p >= 1 && p <= total && p !== cur) { state.page = p; refresh(); window.scrollTo({ top: 0, behavior: 'smooth' }); }
      };
    });
  }

  let inflight = 0;
  var BASE_FACETS = null;
  async function loadBaseFacets() {
    var bf = IS_NEW ? '' : (META_FILTER ? ('(' + META_FILTER + ')') : (COLLECTION ? ('ce_collections = "' + esc(COLLECTION) + '"') : ''));
    var body = { q: state.q, facets: FACETS.map(function (f) { return f.key; }), hitsPerPage: 0 };
    if (bf) body.filter = bf;
    try {
      var res = await fetch(SEARCH_URL + '/indexes/' + INDEX + '/search', { method: 'POST', headers: { 'Authorization': 'Bearer ' + TENANT_TOKEN, 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      var d = await res.json();
      BASE_FACETS = d.facetDistribution || {};
    } catch (e) { BASE_FACETS = {}; }
  }
  async function refresh() {
    writeURL();
    const my = ++inflight;
    root.classList.add('ce-sp--loading');
    try {
      const data = await query();
      if (my !== inflight) return;
      // Disjunctive facet counts: options of a facet you've filtered keep their real counts
      // (selecting Bags must not zero the other categories) — one extra query per active facet.
      var selKeys = Object.keys(state.filters).filter(function (k) { return (state.filters[k] || []).length; });
      if (selKeys.length) {
        try {
          var mq = selKeys.map(function (k) {
            var f = buildFilter(k);
            var qq = { indexUid: INDEX, q: state.q, facets: [k], limit: 0 }; if (state.q && state._ms) qq.matchingStrategy = state._ms;
            if (f) qq.filter = f;
            return qq;
          });
          var mres = await fetch(SEARCH_URL + '/multi-search', {
            method: 'POST',
            headers: { 'Authorization': 'Bearer ' + TENANT_TOKEN, 'Content-Type': 'application/json' },
            body: JSON.stringify({ queries: mq })
          }).then(function (r) { return r.json(); });
          if (my !== inflight) return;
          (mres.results || []).forEach(function (rr, i) {
            var k = selKeys[i];
            data.facetDistribution = data.facetDistribution || {};
            if (rr && rr.facetDistribution && rr.facetDistribution[k]) data.facetDistribution[k] = rr.facetDistribution[k];
          });
        } catch (e) {}
      }
      var _om = window.__ceSpOrder;
      if (_om && !state.sort && data && data.hits) {
        data.hits.sort(function (a, b) {
          var ia = (a.handle_ce in _om) ? _om[a.handle_ce] : 1e9;
          var ib = (b.handle_ce in _om) ? _om[b.handle_ce] : 1e9;
          return ia - ib;
        });
      }
      if (BASE_FACETS === null) { await loadBaseFacets(); if (my !== inflight) return; }
      document.getElementById('CeCount').textContent =
        (data.totalHits != null ? data.totalHits : (data.estimatedTotalHits || 0)).toLocaleString() +
        (state.q ? ' results for “' + state.q + '”' : ' items');
      // loose-fallback notice: no items matched every word of the query
      (function(){
        var ce=document.getElementById('CeCount');
        var note=document.getElementById('CeLooseNote');
        if (state.q && state._ms === 'last') {
          if (!note) { note=document.createElement('div'); note.id='CeLooseNote'; note.className='ce-sp__loosenote'; note.style.cssText='font-size:.84rem;opacity:.6;margin:2px 0 14px;width:100%;text-align:left'; var bar=ce.parentNode; bar.parentNode.insertBefore(note, bar.nextSibling); }
          note.textContent='No exact matches for “'+state.q+'” — showing the closest pieces instead.';
        } else if (note) { note.remove(); }
      })();
      renderFacets(data.facetDistribution);
      renderChips();
      renderGrid(data);
      renderPager(data);
      renderSort();
    } finally {
      if (my === inflight) root.classList.remove('ce-sp--loading');
    }
  }

  // live re-query when typing in the on-page search input (Fashionphile feel)
  function bindLiveInput() {
    const input = document.querySelector('.search-page-input, input[type="search"][name="q"]');
    if (!input) return;
    let t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        state.q = input.value.trim(); state._ms = null;
        state.page = 1;
        refresh();
      }, 200);
    });
  }

  // mobile filters toggle
  function bindToggle() {
    document.getElementById('CeFilterToggle').onclick = function () {
      root.classList.toggle('ce-sp--facets-open');
    };
  }

  // Re-lock the engine to a different base set without a page reload (used by /pages/for-you tabs)
  window.ceSpSetBaseFilter = function (f, tabName) {
    META_FILTER = (f || '').trim();
    root.dataset.meiliFilter = META_FILTER;
    BASE_FACETS = null;
    state.filters = {}; state.priceMin = ''; state.priceMax = ''; state.priceBuckets = []; state.sale = false; state.page = 1;
    if (tabName !== undefined) {
      var u = new URL(location.href);
      if (tabName) u.searchParams.set('tab', tabName); else u.searchParams.delete('tab');
      history.replaceState({}, '', u);
    }
    refresh();
  };

  readURL();
  root.innerHTML = skeleton();
  // NOTE: the collection intro (title + description) stays in its own section ABOVE the
  // slider — we no longer relocate it into the grid (that pushed it below the slider).
  renderSort();
  bindToggle();
  bindLiveInput();
  document.addEventListener('click', function () { var m = document.querySelector('.ce-sp__sort-menu'); if (m) m.hidden = true; });
  refresh();
})();
